import dayjs from "dayjs";

import { fullMonthAndYear, shortMonthAndDay } from "@similarweb/pro-logic-components";

import type { GrowthOverviewGranularity } from "../const";
import { GrowthOverviewGranularity as GrowthOverviewGranularityValues } from "../const";

import { normalizeGrowthOverviewGranularity } from "./granularityUtils";
import { getQuarterNumber, parseGrowthOverviewDate } from "./growthOverviewDateUtils";

const formatWeeklyRange = (start: dayjs.Dayjs, intervalEnd?: dayjs.Dayjs): string => {
    const weekEnd = start.add(6, "day");
    const end =
        intervalEnd != null && (intervalEnd.isBefore(weekEnd, "day") || intervalEnd.isSame(weekEnd, "day"))
            ? intervalEnd
            : weekEnd;

    if (start.isSame(end, "day")) {
        return `${start.format(shortMonthAndDay)}–${end.format("D")}`;
    }

    if (start.month() === end.month()) {
        return `${start.format(shortMonthAndDay)}–${end.format("D")}`;
    }
    return `${start.format(shortMonthAndDay)} – ${end.format(shortMonthAndDay)}`;
};

const formatQuarterlyRange = (date: dayjs.Dayjs): string => {
    const quarter = getQuarterNumber(date);
    const quarterStartMonth = (quarter - 1) * 3;
    const start = date.month(quarterStartMonth).startOf("month");
    const end = start.add(2, "month");
    return `Q${quarter} ${date.year()} (${start.format("MMM")}–${end.format("MMM")})`;
};

export const getPeriodRangeLabel = (
    date: string,
    granularity: GrowthOverviewGranularity | string,
    intervalEnd?: dayjs.Dayjs,
): string => {
    const parsed = parseGrowthOverviewDate(date) ?? dayjs(date);
    const normalizedGranularity = normalizeGrowthOverviewGranularity(granularity);

    if (normalizedGranularity === GrowthOverviewGranularityValues.Weekly) {
        return formatWeeklyRange(parsed, intervalEnd);
    }

    if (normalizedGranularity === GrowthOverviewGranularityValues.Quarterly) {
        return formatQuarterlyRange(parsed);
    }

    return parsed.format(fullMonthAndYear);
};
